import React, { useState } from 'react';

const WalksStats = () => {
  const [timeFrame, setTimeFrame] = useState('diario');

  const stats = {
    diario: { walksDone: 8, walksScheduled: 12, distance: '5.2 km', time: '2h 45m' },
    semanal: { walksDone: 42, walksScheduled: 60, distance: '32.7 km', time: '14h 30m' },
    mensual: { walksDone: 180, walksScheduled: 240, distance: '142.5 km', time: '62h 15m' }
  };

  return (
    <div className="ml-64 p-6 grid grid-cols-1 md:grid-cols-4 gap-6">
      <div className="bg-white rounded-xl shadow-sm p-6 col-span-4">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Vista general del día</h3>
        
        <div className="flex space-x-4 mb-6">
          <button 
            onClick={() => setTimeFrame('diario')}
            className={`px-4 py-2 rounded-lg ${timeFrame === 'diario' ? 'bg-cyan-600 text-white' : 'bg-gray-100 text-gray-700'}`}
          >
            Diario
          </button>
          <button 
            onClick={() => setTimeFrame('semanal')}
            className={`px-4 py-2 rounded-lg ${timeFrame === 'semanal' ? 'bg-cyan-600 text-white' : 'bg-gray-100 text-gray-700'}`}
          >
            Semanal
          </button>
          <button 
            onClick={() => setTimeFrame('mensual')}
            className={`px-4 py-2 rounded-lg ${timeFrame === 'mensual' ? 'bg-cyan-600 text-white' : 'bg-gray-100 text-gray-700'}`}
          >
            Mensual
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-cyan-50 rounded-lg p-4">
            <p className="text-sm text-cyan-600">Paseos realizados</p>
            <p className="text-2xl font-bold">{stats[timeFrame].walksDone}</p>
          </div>
          <div className="bg-purple-50 rounded-lg p-4">
            <p className="text-sm text-purple-600">Paseos agendados</p>
            <p className="text-2xl font-bold">{stats[timeFrame].walksScheduled}</p>
          </div>
          <div className="bg-green-50 rounded-lg p-4">
            <p className="text-sm text-green-600">Kilómetros caminados</p>
            <p className="text-2xl font-bold">{stats[timeFrame].distance}</p>
          </div>
          <div className="bg-orange-50 rounded-lg p-4">
            <p className="text-sm text-orange-600">Tiempo total</p>
            <p className="text-2xl font-bold">{stats[timeFrame].time}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalksStats;

// DONE